import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SmoothExpand } from './SmoothExpand';

/**
 * Accessible expand/collapse with smooth height animation.
 * @param {{
 *   summary: React.ReactNode;
 *   children: React.ReactNode;
 *   className?: string;
 *   summaryClassName?: string;
 *   contentClassName?: string;
 *   defaultOpen?: boolean;
 *   showChevron?: boolean;
 *   chevronClassName?: string;
 * }} props
 */
export function ExpandableSection({
  summary,
  children,
  className = '',
  summaryClassName = '',
  contentClassName = '',
  defaultOpen = false,
  showChevron = true,
  chevronClassName = '',
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={className}>
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className={`flex w-full cursor-pointer items-center justify-between gap-2 text-left ${summaryClassName}`}
      >
        <span className="min-w-0 flex-1">{summary}</span>
        {showChevron ? (
          <ChevronDown
            className={`h-3.5 w-3.5 shrink-0 transition-transform duration-300 ${open ? 'rotate-180' : ''} ${chevronClassName}`}
            aria-hidden
          />
        ) : null}
      </button>
      <SmoothExpand open={open}>
        <div className={contentClassName}>{children}</div>
      </SmoothExpand>
    </div>
  );
}
